import React, { useEffect } from "react"
import { AuctionWonNotification } from "./AuctionWonNotification"
import { TradeNotification } from "./TradeNotification"
import { BankruptNotification } from "./BankruptNotificaiton"
import { TurnStartedNotification } from "./TurnStartedNotification"
import { AuctionTiedNotification } from "./AuctionTiedNotification"
import { TurnAutoEndedNotification } from "./TurnAutoEnded"
import { PrivateBuyNotification } from "./PrivateBuyNotification"
import { ChallengeCompletedNotification } from "./ChallengeCompletedNotification"
import { FastPaceVoteStartedNotification } from "./FastPaceVoteStartedNotification"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { removeNotification } from "@/store/globalSlice"
// Import other notification components...

const CenterNotifications: React.FC = () => {
  const notifications = useAppSelector((state) => state.global.notifications)
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Automatically remove notifications after their duration
    const timers = notifications.map((notification) =>
      setTimeout(() => {
        dispatch(removeNotification(notification.type))
        // if(notification.onComplete)
        notification?.onComplete?.()
      }, notification?.duration)
    )

    return () => timers.forEach(clearTimeout) // Cleanup on unmount
  }, [notifications, dispatch])

  return (
    <div className="fixed top-0 left-0 z-[200] w-full flex flex-col items-center gap-4">
      {notifications.map((notification) => {
        switch (notification.type) {
          case "auction-won":
            return <AuctionWonNotification {...notification} />

          case "trade":
            return <TradeNotification {...notification} />

          case "bankrupt":
            return <BankruptNotification {...notification} />

          case "turn-started":
            return <TurnStartedNotification {...notification} />
          case "auction-tied":
            return <AuctionTiedNotification {...notification} />
          case "turn-auto-ended":
            return <TurnAutoEndedNotification {...notification} />
          case "private-buy":
            return <PrivateBuyNotification {...notification} />
          case "challenge-completed":
            return <ChallengeCompletedNotification {...notification} />
          case "fast-pace-vote-started":
            return <FastPaceVoteStartedNotification {...notification} />
          default:
            return null
        }
      })}
    </div>
  )
}
export default CenterNotifications
